import React, { useState, useEffect, useMemo, useRef } from 'react';
import {
  Container,
  FormGroup,
  Label,
  Input,
  Button,
  CustomInput,
  Row,
  Col,
  Modal,
  ModalHeader,
  ModalBody,
  InputGroup, InputGroupAddon, InputGroupText
} from 'reactstrap';
import { connect } from 'react-redux';
import { IAuthReduxProps, IUser, IUserEdit, IUserEditRedux, ITarget } from '../../types/interfaces';

import TableContainer from "../tables_manager/TableContainer"
import EditableCell from "../tables_manager/EditableCell";
import Select from 'react-select';
import AsyncSelect from 'react-select/async';
import CreatableSelect from 'react-select/creatable';
import { getUsers, editUser } from '../../flux/actions/userActions';
import { getAllSocietes } from '../../flux/actions/societeActions';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheckCircle, faExternalLinkAlt, faPen, faPlus, faSpinner, faTimes } from '@fortawesome/free-solid-svg-icons'
import axios from 'axios';
import { E_ERROR } from '../../types/errors';
import { useAlert } from "react-alert";
import moment from "moment";

import PhoneInput from "react-phone-input-2";
import frPhoneInput from 'react-phone-input-2/lang/fr.json'
import 'react-phone-input-2/lib/bootstrap.css'
import { constants } from '../../types/constants';

const UserEdit = ({
  modal,
  setModal,
  handleToggle,
  modalUser,
  editUser,
  societes,
  users,
  auth
 }: IUserEdit) => {
  const [idValue, setIdValue] = useState(-1);
  const [givenNameValue, setGivenName] = useState('');
  const [surnameValue, setSurname] = useState('');
  // const [nameValue, setName] = useState('');
  const [usernameValue, setUsername] = useState('');
  const [telValue, setTel] = useState<any>('');
  const [telIsValid, setTelIsValid] = useState(true);
  const selectSOptions = societes.map(e => ({value: e.id, label: e.LIBELE, societe: e}));
  const [societesValue, setSocietesValue] = useState([]);
  const [worksAtSocietesValue, setWorksAtSocietesValue] = useState([]);
  const selectUOptions = users.filter(e => !modalUser || e.id !== modalUser["id"]).map(e => ({value: e.id, label: e["LOGIN"] || e.username, user: e}));
  const [underlingsValue, setUnderlingsValue] = useState([]);
  const [blockedValue, setBlockedValue] = useState(false);
  const [observationValue, setObservation] = useState('');
  const specialities = {
    [constants.ROLE_ADMIN]: {
      color: "black",
      text: "Administrateur"
    },
    [constants.ROLE_COMMERCIAL]: {
      color: "darkgreen",
      text: "Commercial"
    },
    [constants.ROLE_COMPTABLE]: {
      color: "darkblue",
      text: "Comptable"
    },
    [constants.ROLE_RESPONSABLE]: {
      color: "saddlebrown",
      text: "Responsable"
    },
    [constants.ROLE_PROMOTEUR]: {
      color: "saddlebrown",
      text: "Promoteur"
    },
    [constants.ROLE_INTERMEDIAIRE]: {
      color: "saddlebrown",
      text: "Intermédiaire"
    },
    [constants.ROLE_DG]: {
      color: "dimgrey",
      text: "Directeur Général"
    },
    [constants.ROLE_DC]: {
      color: "saddlebrown",
      text: "Directeur Commercial"
    },
    [constants.ROLE_DAF]: {
      color: "rebeccapurple",
      text: "Directeur Administratif et Financier"
    },
  };
  const selectOptions = [{value: constants.ROLE_ADMIN, label: specialities[constants.ROLE_ADMIN].text}, {value: constants.ROLE_COMMERCIAL, label: specialities[constants.ROLE_COMMERCIAL].text}, {value: constants.ROLE_RESPONSABLE, label: specialities[constants.ROLE_RESPONSABLE].text}, {value: constants.ROLE_PROMOTEUR, label: specialities[constants.ROLE_PROMOTEUR].text}, {value: constants.ROLE_INTERMEDIAIRE, label: specialities[constants.ROLE_INTERMEDIAIRE].text}, {value: constants.ROLE_COMPTABLE, label: specialities[constants.ROLE_COMPTABLE].text}];
  const [selectedValue, setSelectedValue] = useState<any>('');
  const [specialityDisabled, setSpecialityDisabled] = useState(false);
  const [disableSubmit, setDisableSubmit] = useState(false);
  const [reEnable, setReEnable] = useState(false);

  const alert = useAlert();

  const modalOpenedHandle = () => {
    if(modalUser && modalUser !== ''){
      setIdValue(modalUser["id"]);
      setGivenName(modalUser["given_name"]);
      setSurname(modalUser["surname"]);
      // setName(modalUser["name"]);
      setUsername(modalUser["username"]);
      if(modalUser["phone"])
        setTel({
          value: (modalUser["phone"].length === 10 && modalUser["phone"][0] === '0') ? ("212" + modalUser["phone"].substr(1, modalUser["phone"].length - 1)) : modalUser["phone"],
          t: {
            dialCode: (modalUser["phone"].length === 10 && modalUser["phone"][0] === '0') || (modalUser["phone"].length === 12 && modalUser["phone"].substr(0, 3) === '212') ? "212" : modalUser["phone"].substr(0, modalUser["phone"].length - 9)
          }
        });
      else
        setTel('')
      if([constants.ROLE_DG, constants.ROLE_DC, constants.ROLE_DAF].includes(modalUser["speciality"])){
        setSelectedValue({value: modalUser["speciality"], label: specialities[modalUser["speciality"]].text});
        setSpecialityDisabled(true);
      }
      else{
        setSelectedValue(selectOptions.find(e => modalUser["speciality"] === e.value) || '');
        setSpecialityDisabled(false);
      }
      setSocietesValue(modalUser["societes"] || []);
      setWorksAtSocietesValue(modalUser["worksatProjects"] || []);
      setUnderlingsValue(modalUser["underlings"] || [])
      setBlockedValue(modalUser["bloque"] === 1)
      setObservation(modalUser["comment"]);
    }
  };

  const modalClosedHandle = () => {
    setIdValue(-1);
    setGivenName('');
    setSurname('');
    // setName('');
    setUsername('');
    setTel('');
    setSelectedValue('');
    setSocietesValue([]);
    setWorksAtSocietesValue([]);
    setUnderlingsValue([]);
    setBlockedValue(false)
    setObservation('');
    if(reEnable){
      setDisableSubmit(false);
      setReEnable(false);
    }
  };

  const givenNameChangeHandler = (e: ITarget) => setGivenName(e.target.value);
  const surnameChangeHandler = (e: ITarget) => setSurname(e.target.value);
  // const nameChangeHandler = (e: ITarget) => setName(e.target.value);
  const usernameChangeHandler = (e: ITarget) => setUsername(e.target.value);
  const telChangeHandler = (value, t) => setTel({value, t});
  const handleSelectChange = data => {
    setSelectedValue(data || '');
  }
  const handleSocietesChange = data => {
    setSocietesValue(data?.length ? data.map(e => e.societe) : []);
  }
  const handleWorksAtSocietesChange = data => {
    setWorksAtSocietesValue(data?.length ? data.map(e => e.societe) : []);
  }
  const handleUnderlingsChange = data => {
    setUnderlingsValue(data?.length ? data.map(e => e.user) : []);
  }
  const changeBlockedHandle = (e) => {
    setBlockedValue(e.target.checked);
  };
  const observationChangeHandler = (e: ITarget) => setObservation(e.target.value);

  const callback = (success) => {
    if(success){
      setReEnable(true);
      setModal(false);
      alert.success("Utilisateur modifié avec succès");
      return
    }
    alert.error("Une erreur s'est produite");
    setDisableSubmit(false);
  }

  const editHandle = async () => {
    if(givenNameValue === ''){
      alert.error("Veuillez saisir le prénom");
      return
    }
    if(surnameValue === ''){
      alert.error("Veuillez saisir le nom");
      return
    }
    // if(nameValue === ''){
    //   alert.error("Veuillez saisir le nom");
    //   return
    // }
    if(usernameValue === ''){
      alert.error("Veuillez saisir le nom de compte");
      return
    }
    if(!telIsValid){
      alert.error("N° de téléphone erroné");
      return
    }
    if(selectedValue === ''){
      alert.error("Veuillez sélectionner un rôle");
      return
    }

    const user : IUser = {
      id: idValue,
      given_name: givenNameValue,
      surname: surnameValue,
      // name: nameValue,
      username: usernameValue,
      phone: telValue?.value ? (telValue.t.dialCode === "212" ? (telValue.value.length > 4 ? ("0" + telValue.value.substr(3)) : "") : telValue.value) : "",
      speciality: selectedValue?.value || undefined,
      bloque: blockedValue ? 1 : 0,
      comment: observationValue
    };
    setDisableSubmit(true);
    editUser(user, societesValue, worksAtSocietesValue, underlingsValue, callback);
  };

  return (
    <div>
      <Modal isOpen={modal} toggle={handleToggle} onOpened={modalOpenedHandle} onClosed={modalClosedHandle}>
        <ModalHeader toggle={handleToggle}><FontAwesomeIcon icon={faPen} />&nbsp;&nbsp;Modification des utilisateurs</ModalHeader>
        <ModalBody>
            <Container className="linesConfirmationContainer">
              <Row>
                <Col xs="12">
                  <FormGroup>
                    <Label for="name">Prénom</Label>
                    <Input id="name" placeholder="Prénom..." value={givenNameValue} onChange={givenNameChangeHandler} />
                  </FormGroup>
                </Col>
              </Row>
              <Row>
                <Col xs="12">
                  <FormGroup>
                    <Label for="name">Nom</Label>
                    <Input id="name" placeholder="Nom de famille..." value={surnameValue} onChange={surnameChangeHandler} />
                  </FormGroup>
                </Col>
              </Row>
              {/* <Row>
                <Col xs="12">
                  <FormGroup>
                    <Label for="name">Nom</Label>
                    <Input id="name" placeholder="Nom complet..." value={nameValue} onChange={nameChangeHandler} />
                  </FormGroup>
                </Col>
              </Row> */}
              <Row>
                <Col xs="12">
                  <FormGroup>
                    <Label for="username">Nom de compte</Label>
                    <Input id="username" placeholder="Nom de compte..." value={usernameValue} onChange={usernameChangeHandler} />
                  </FormGroup>
                </Col>
              </Row>
              <Row>
                <Col xs="12">
                  <FormGroup>
                    <Label for="tel">N° de Téléphone</Label>
                    <PhoneInput
                      value={telValue?.value || ""}
                      onChange={telChangeHandler}
                      inputProps={{
                        id: "tel",
                        required: false,
                        autoFocus: false
                      }}
                      inputStyle={{width: "100%"}}
                      localization={frPhoneInput}
                      masks={{ ma: '... .. .. ..' }}
                      country="ma"
                      preferredCountries={["ma"]}
                      countryCodeEditable={false}
                      enableSearch={true}
                      searchPlaceholder="Rechercher..."
                      isValid={(value, country) => {
                        const isValid = country["iso2"] !== "ma" || value.length - country["dialCode"].length === 9 || value.length - country["dialCode"].length === 0;
                        setTelIsValid(isValid);
                        return isValid
                        // return value.length - country["dialCode"].length === 9 || value.length - country["dialCode"].length === 0
                      }}
                    />
                  </FormGroup>
                </Col>
              </Row>
              <Row>
                <Col xs="12">
                  <FormGroup>
                    <Label for="speciality">Spécialité</Label>
                    <Select
                      id="speciality"
                      className="reactselect"
                      classNamePrefix="react-select"
                      defaultValue={selectOptions[0]}
                      value={selectedValue}
                      // value={{value: societeValue.value, label: societeValue.label}}
                      onChange={handleSelectChange}
                      isClearable={false}
                      loadingMessage={() => 'Chargement...'}
                      noOptionsMessage={() => 'pas de resultat'}
                      isSearchable={false}
                      options={selectOptions}
                      isDisabled={specialityDisabled}
                    />
                  </FormGroup>
                </Col>
              </Row>
              <Row>
                <Col xs="12">
                  <FormGroup>
                    <Label for="worksAt">Travaille à</Label>
                    <Select
                      id="worksAt"
                      className="reactselect"
                      classNamePrefix="react-select"
                      isMulti
                      value={worksAtSocietesValue?.map(e => ({label: e["LIBELE"], value: e["id"], societe: e})) || []}
                      onChange={handleWorksAtSocietesChange}
                      placeholder={'Chercher...'}
                      isClearable={true}
                      // isLoading={loadingS}
                      loadingMessage={() => 'Chargement...'}
                      noOptionsMessage={() => 'pas de resultat'}
                      isSearchable={true}
                      labelKey='LIBELE'
                      options={selectSOptions}
                      menuContainerStyle={{ zIndex: 9999999 }} />
                  </FormGroup>
                </Col>
              </Row>
              <Row>
                <Col xs="12">
                  <FormGroup>
                    <Label for="societes">Projet(s)</Label>
                    <Select
                      id="societes"
                      className="reactselect"
                      classNamePrefix="react-select"
                      isMulti
                      value={societesValue?.map(e => ({label: e["LIBELE"], value: e["id"], societe: e})) || []}
                      onChange={handleSocietesChange}
                      placeholder={'Chercher...'}
                      isClearable={true}
                      // isLoading={loadingS}
                      loadingMessage={() => 'Chargement...'}
                      noOptionsMessage={() => 'pas de resultat'}
                      isSearchable={true}
                      labelKey='LIBELE'
                      options={selectSOptions}
                      menuContainerStyle={{ zIndex: 9999999 }} />
                  </FormGroup>
                </Col>
              </Row>
              <Row style={{display: "none"}}>
                <Col xs="12">
                  <FormGroup>
                    <Label for="underlings">A l'accès à leurs activités</Label>
                    <Select
                      id="underlings"
                      className="reactselect"
                      classNamePrefix="react-select"
                      isMulti
                      value={underlingsValue?.map(e => ({label: e["LOGIN"] || e["username"], value: e["id"], user: e})) || []}
                      onChange={handleUnderlingsChange}
                      placeholder={'Chercher...'}
                      isClearable={true}
                      // isLoading={loadingU}
                      loadingMessage={() => 'Chargement...'}
                      noOptionsMessage={() => 'pas de resultat'}
                      isSearchable={true}
                      labelKey='LOGIN'
                      options={selectUOptions}
                      menuContainerStyle={{ zIndex: 9999999 }} />
                  </FormGroup>
                </Col>
              </Row>
              <Row>
                <Col xs="12">
                  <FormGroup className="formCustomSwitch">
                    <Label for="allowed">Compte bloqué</Label>
                    <CustomInput type="switch" id="allowed" name="allowedSwitch" className="switchDanger" checked={blockedValue} onChange={changeBlockedHandle} />
                  </FormGroup>
                </Col>
              </Row>
              <Row>
                <Col xs="12">
                  <FormGroup>
                    <Label for="observation">Observation</Label>
                    <Input id="observation" placeholder="Commentaire..." value={observationValue} onChange={observationChangeHandler} />
                  </FormGroup>
                </Col>
              </Row>
              <Row className="justify-content-center">
                <Button
                  className="btn btn-success linesConfirmationBtn"
                  onClick={editHandle}
                  disabled={disableSubmit}
                  ><FontAwesomeIcon icon={disableSubmit ? faSpinner : faCheckCircle} className={disableSubmit ? "spinner" : ""} />&nbsp;&nbsp;Modifier</Button>
              </Row>
            </Container>
        </ModalBody>
      </Modal>
    </div>
  );
};

const mapStateToProps = (state: IUserEditRedux) => ({
  auth: state.auth,
  error: state.error,
  societe: state.societe,
  user: state.user,
});

export default connect(mapStateToProps, { editUser, getAllSocietes, getUsers })(UserEdit);
